import video1 from '../../asset/images/clip-01.jpg'
import video2 from '../../asset/images/clip-02.jpg'
import video3 from '../../asset/images/clip-03.jpg'
import video4 from '../../asset/images/clip-04.jpg'

const VideoCardData = [
    { id: 'Video1', image: video1, name: 'First Clip', seen: '250' },
    { id: 'Video1', image: video2, name: 'Second Clip', seen: '185' },
    { id: 'Video1', image: video3, name: 'Third Clip', seen: '65' },
    { id: 'Video1', image: video4, name: 'Fourth Clip', seen: '115' },
]

export default VideoCardData